module.exports = __webpack_public_path__ + "static/img/new_df61.6eddf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_df61.png
// module id = QXo0
// module chunks = 101